/**
 * Created by Patrick on 7/5/2019.
 */

import React, { Component } from "react";
import LoadingSpinner from "../components/LoadingSpinner";
import Row from '../components/Row'
import NoRecordsFound from '../components/NoRecordsFound'

class DevicesList extends Component {
  headers = [
    {
      key: "name",
      name: "Name",
      width: 3
    },
    {
      key: "model",
      name: "Model",
      width: 3
    },
    {
      key: "osVersion",
      name: "Version",
      width: 3
    },
    {
      key: "remove",
      name: "Remove",
      sortable: false,
      width: 3
    }
  ]


  renderTableHeaders = () => {
    const { onSort, sortBy, isSortAsc } = this.props;
    const arrow = isSortAsc ? <span className="glyphicon glyphicon-triangle-top" title="Ascending" /> : <span className="glyphicon glyphicon-triangle-bottom" title="Descending"/>

    return this.headers.map(({ key, name, width, sortable }) => {
        if (sortable === false) {
            return (
                <th key={key}>
                    <div className={`text-center table-header col-sm-${width}`}>{name}</div>
                </th>
            )
        }

        return (
            <th key={key}  onClick={() => onSort(key)}>
                <div className={`text-center table-header table-header-clickable col-sm-${width} flex-center`} >
                    {name} {sortBy === key && arrow }
                </div>
            </th>
        )
    })
  }

  renderTableRows = () => {
    const { devices, onRemove } = this.props;

    if (devices.length) {
      return devices.map(device => {
        const removeButton = (<a className="remove-device-cluster">
                                <span className="glyphicon glyphicon-minus remove-button" />
                             </a>)

        // Select what fields should be displayed in the row
        const selectedFields = {
          name: device.name,
          model: device.model,
          osVersion: device.osVersion,
          remove: removeButton
        }
  
        return (
          <Row 
            key={device._id} 
            data={selectedFields}
            onClick={() => onRemove(device._id)}
          />
        );
      });
    }

    return <NoRecordsFound />
  }

  render() {
    const { isLoading } = this.props;

    return (
      <div className="test-instance-list">
        { isLoading ? <div className="flex-center"><LoadingSpinner /></div> : (
              <table className="table">
                <thead className="test-instance-details-head">
                  <tr>
                    { this.renderTableHeaders() }
                  </tr>
                </thead>
                <tbody>
                  { this.renderTableRows() }
                </tbody>
              </table>
        )}
      </div>
    ); // return
  } // render
} // DevicesList

export default DevicesList;
